import { render } from "./SegmentationComplexPropertyDropdown.vue?vue&type=template&id=36e0d010"
import script from "./SegmentationComplexPropertyDropdown.vue?vue&type=script&lang=ts"
export * from "./SegmentationComplexPropertyDropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script